<!-- tabbar.vue组件文件 -->

<template>
  <div class="tabbar">
    <div
      :class="['tabbar-item', isShow == index ? 'is-show' : '']"
      v-for="(item, index) in list"
      :key="index"
      @click="tabbarChange(item.path,index)"
    >
      <img
        class="item-img"
        :src="item.icon_a"
        v-if="current == index"
      />
      <img class="item-img" :src="item.icon" v-else />
      <div
        class="item-name"
        :class="{ tabbarActive: current == index }"
        v-if="item.text"
      >
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import Tabbar from "@/components/tabbar.vue";


export default {
  props: {
    current: Number,
    isShow: Number,
  },
  data() {
    return {
      paddingBottomHeight: 0, //苹果X以上手机底部适配高度
      list: [
        {
          text: "素材",
          icon: require("../assets/imgs/tab/material.png"), //未选中图标
          icon_a: require("../assets/imgs/tab/material_show.png"), //选中图片
          path: "/Material", //页面路径
        },
        {
          text: "话术",
          icon: require("../assets/imgs/tab/script.png"),
          icon_a: require("../assets/imgs/tab/script_show.png"),
          path: "/Script",
        },
        // {
        //   text: "推荐",
        //   icon: require("../assets/imgs/tab/recommend.png"),
        //   icon_a: require("../assets/imgs/tab/recommend_show.png"),
        //   path: "/Recommend",
        // },
      ],
    };
  },
  created() {},
  methods: {
    tabbarChange(path, index) {
     this.current == index ? "" : this.$router.push(path)
      
    },
  },
};
</script>

<style scoped>

.tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 125px;
  background-color: #fff;
  border-top: 1px solid #EDEDF7;
}

.tabbar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100px;
}

.item-img {
  width: 45px;
  height: 45px;
}

.item-name {
  font-size: 22px;
  margin-top: 5px;
  color: #B2B4B6;
}

.tabbarActive {
    font-weight: 600;
      color: #101F48;
}

.is-show {
  display: none !important;
}
</style>
